import styled from 'styled-components';
export const ScrollableContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  /* border: 5px solid red; */
`;
export const TableContainer = styled.div`
  overflow-x: auto;
  /* margin: 2rem 0; */
  overflow-y: visible;
  position: relative;
  /* border: 5px solid orange; */
  scrollbar-color: var(--yellow1) var(--yellow4);
`;
export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  text-align: left;
  /* border: 5px solid yellow; */
`;

export const TableHeader = styled.th`
  background-color: var(--grey1);
  color: var(--grey7);
  padding: 1rem;
  border: 1px solid var(--grey15);
  font-weight: bold;
  /* border: 5px solid red; */
  min-width: 150px;
  text-align: center;
  font-size: 0.8rem;
  position: relative;
  &:first-child {
    position: sticky;
    left: 0;
    background-color: var(--grey1);
    z-index: 1;
  }
`;

export const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: var(--offWhite);
  }
`;

export const TableCell = styled.td`
  padding: 1rem;
  border: 1px solid var(--grey1);
  text-align: center;
  /* border: 5px solid red; */
  &:first-child {
    position: sticky;
    left: 0;
    background-color: var(--grey15);
    z-index: 1;
  }
`;

export const StatusDot = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: ${({ status }) => {
    switch (status) {
      case 'completed':
        return 'var(--successGreen)';
      case 'in-progress':
        return 'var(--orange4)';
      case 'expired':
        return 'var(--errorRed)';
      default:
        return 'transparent';
    }
  }};
  /* margin: 0 auto; */
  &:hover {
    cursor: pointer;
    background-color: ${({ status }) => {
      switch (status) {
        case 'completed':
          return 'var(--lightGreen)';
        case 'in-progress':
          return 'var(--orange1)';
        case 'expired':
          return 'var(--lightRed)';
        default:
          return 'transparent';
      }
    }};
    border: 2px solid
      ${({ status }) => {
        switch (status) {
          case 'completed':
            return 'var(--successGreen)';
          case 'in-progress':
            return 'var(--orange4)';
          case 'expired':
            return 'var(--errorRed)';
          default:
            return 'transparent';
        }
      }};
  }
`;

export const CourseDetailsContainer = styled.aside`
  display: flex;
  flex-direction: column;
  /* gap: 0.5rem; */
  padding: 1rem;
  background-color: var(--offWhite);
  /* border-left: 4px solid var(--successGreen); */
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transform: translateY(-50px);
  animation: dropIn 0.5s ease forwards;
  margin-bottom: 1rem;
  /* border: 1px solid red; */
  border-left: 5px solid
    ${({ status }) => {
      switch (status) {
        case 'completed':
          return 'var(--successGreen)';
        case 'in-progress':
          return 'var(--orange4)';
        case 'expired':
          return 'var(--errorRed)';
        default:
          return 'transparent';
      }
    }};
  h3 {
    border-bottom: none;
    margin: 0;
    margin-bottom: 0.3rem;
  }
  @keyframes dropIn {
    to {
      transform: translateY(0);
    }
  }
  dt {
    font-weight: bold;
    color: ${({ theme }) => theme.colors.grey6};
    /* border: 5px solid yellow; */
  }

  dd {
    margin: 0;
    color: ${({ theme }) => theme.colors.grey4};
  }
`;
export const DotLegendContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  margin-block: 0.5rem;
`;
export const DownloadContainer = styled.div`
  position: relative;
  display: inline-block;
  display: flex;
  justify-content: end;
  /* border: 1px solid red; */
`;

export const DropdownMenu = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  background-color: ${({ theme }) => theme.colors.yellow4};
  border-radius: ${({ theme }) => theme.borderRadius};
  box-shadow: ${({ theme }) => theme.shadows.shadow3};
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  z-index: 10;
  /* border: 2px solid red; */
`;

export const TooltipContainer = styled.div`
  visibility: hidden;
  background-color: ${({ theme }) => theme.colors.grey6};
  color: ${({ theme }) => theme.colors.grey1};
  text-align: center;
  padding: 0.5rem;
  border-radius: ${({ theme }) => theme.borderRadius};
  position: absolute;
  z-index: 10;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  box-shadow: ${({ theme }) => theme.shadows.shadow2};
  white-space: nowrap;

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border-width: 5px;
    border-style: solid;
    border-color: ${({ theme }) => theme.colors.grey6} transparent transparent
      transparent;
  }
`;
